import React from 'react'
import { connect } from 'dva'
import { framework_tool, component_tool, utils_tool } from '@/tool'
import { modelUtils } from '@/utils'
import { Table } from 'antd'
const { WizSpin, WizButton, WizCard } = component_tool
const { WizContainer } = framework_tool
const { Session } = utils_tool

import CounselingHeader from '../header'

const findParamRecord = (history) => {
    let record = {}
    if (history.location && history.location.pathname === '/integrationCounseling/manager/onlineNotification/postPersonnel') {
        if (history.location && history.location.record) {
            record = history.location.record
            Session.set('onlineNotificationPostPersonnel', record)
        } else {
            record = Session.get('onlineNotificationPostPersonnel') || {}
        }
    }
    return record
}

class PostPersonnel extends WizContainer {

    componentName = 'PostPersonnel'

    constructor(props) {
        super(props)
        let record = findParamRecord(props.history)
        this.state = {
            record
        }
    }

    _componentDidMount() {
        this._list()
    }

    _list = () => {
        const { processContentId } = this.state.record
        this.doAction({
            path: 'counselingProcess/postPersonnel',
            payload: {
                key: 'postPersonnel@' + processContentId,
                apiParams: {
                    tutorContentId: processContentId
                }
            }
        })
    }

    // _onBtn = () => {
    //     const { processContentId } = this.state.record
    //     this.doAction({
    //         path: 'counselingProcess/renewPostPersonnel',
    //         payload: {
    //             key: 'renewPostPersonnel@' + processContentId,
    //             apiParams: {
    //                 tutorContentId: processContentId
    //             }
    //         }
    //     })
    // }

    propsAndStateOnChange = {
        list: this._listOnChange.bind(this)
    }

    _listOnChange(nextProps, nextState) {
        if (nextProps.list && nextProps.list.code !== 1) {
            wizNotice.error(nextProps.list.msg)
        }
        return true
    }

    render() {
        let { record } = this.state
        let { list, counselingProcessLoading } = this.props
        let data = list.data || []
        let columns = [{
            title: '岗位',
            name: 'positionName',
            dataIndex: 'positionName',
        }, {
            title: '姓名',
            name: 'fullName',
            dataIndex: 'fullName'
        // }, {
        //     title: '培训进度',
        //     name: 'trainingProgress',
        //     dataIndex: 'trainingProgress'
        }, {
            title: '状态',
            name: 'trainingSituation',
            dataIndex: 'trainingSituation',
            render: (v) => {
                return v === 0 ? '合格' : '不合格'
            }
        }, {
            title: '手机号',
            name: 'mobile',
            dataIndex: 'mobile'
        }, {
            title: '电子邮箱',
            name: 'email',
            dataIndex: 'email'
        }]

        let tableProps = {
            columns,
            dataSource: data,
            pagination: false,
            bordered: true
        }
        return (
            <WizSpin spinning={counselingProcessLoading} >
                <CounselingHeader record={record} />
                <WizCard title='主要岗位人员信息'>
                    {
                        data && data.length
                            ? null :
                            <WizButton type='primary' style={{ marginBottom: 15, width: 90 }} onClick={() => this._list()}>{'重新获取'}</WizButton>
                    }
                    <Table {...tableProps} />
                </WizCard>
            </WizSpin>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    const { counselingProcess } = state
    const { processContentId } = findParamRecord(ownProps.history)
    const list = modelUtils.getModelEntity(counselingProcess, 'postPersonnel@' + processContentId)
    // const renew = modelUtils.getModelEntity(counselingProcess, 'renewPostPersonnel@' + processContentId)
    const loading = modelUtils.getLoadingState(state, 'counselingProcess')
    return {
        list,
        // renew,
        ...loading
    }
}

export default connect(mapStateToProps)(PostPersonnel)


